import builder from '../builder';
import HouseNature from '../../streamline-icons/bold/nature-house.svg';

export default builder('HouseNatureBold', HouseNature);
